import script from "./DowngradeConfirm.vue?vue&type=script&setup=true&lang=js"
export * from "./DowngradeConfirm.vue?vue&type=script&setup=true&lang=js"

import "./DowngradeConfirm.vue?vue&type=style&index=0&id=ba159534&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ba159534"]])

export default __exports__